import {persistStore} from 'redux-persist'
import createFilter from 'redux-persist-transform-filter'

import { asyncLocalStorage } from 'redux-persist/storages'

export default (store, storage, toPersist) => {
	if(storage === 'local'){
		storage = asyncLocalStorage
	}

	return persistStore(store, {
		storage: storage,
		whitelist: Object.keys(toPersist),
		transforms: Object.entries(toPersist).map(([key, val]) => createFilter(key, val, val))
	})
}

export const defaultPersist = {
	Auth: ['username', 'rememberMe', 'pinEnabled', 'firstLogin', 'fingerprintSecret'],
	Notify: ['pushNotificationRegistered'],
	AustraliaPost: ['ausPostDisclaimerAgreed'],
	Features: ['lastSeen'],
	Preferences: ['lastSeenCommVersion']
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/setupPersist.js